import {normalizeIncome} from '../../services/membersOnboardingApi.ts';

export const digits = (value: string) => value.replace(/\D/g, '');
export function nationalPhone(value: string): string {
  const number = digits(value);
  return number.startsWith('55') && number.length > 11 ? number.slice(2) : number;
}
export function formatPhone(value: string): string {
  const number = nationalPhone(value).slice(0, 11);
  if (number.length < 3) return number ? `(${number}` : '';
  const local = number.slice(2);
  const split = local.length > 8 ? 5 : 4;
  return `(${number.slice(0, 2)}) ${local.slice(0, split)}${local.length > split ? `-${local.slice(split)}` : ''}`;
}
export function formatPostalCode(value: string): string {
  return digits(value).slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2');
}
export function formatIncome(value: string): string {
  const canonical = normalizeIncome(value);
  if (!canonical) return '';
  const [integer, fraction] = canonical.split('.');
  return `R$ ${integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${fraction}`;
}
/** Digitação monetária da direita para a esquerda: 1 → 0,01. */
export function incomeFromDigits(value: string): string {
  const number = digits(value).replace(/^0+(?=\d)/, '');
  if (!number || /^0{1,2}$/.test(digits(value))) return '';
  const padded = number.padStart(3, '0');
  return `${padded.slice(0, -2)}.${padded.slice(-2)}`;
}
export const states = [
  ['AC', 'Acre'], ['AL', 'Alagoas'], ['AP', 'Amapá'], ['AM', 'Amazonas'],
  ['BA', 'Bahia'], ['CE', 'Ceará'], ['DF', 'Distrito Federal'], ['ES', 'Espírito Santo'],
  ['GO', 'Goiás'], ['MA', 'Maranhão'], ['MT', 'Mato Grosso'], ['MS', 'Mato Grosso do Sul'],
  ['MG', 'Minas Gerais'], ['PA', 'Pará'], ['PB', 'Paraíba'], ['PR', 'Paraná'],
  ['PE', 'Pernambuco'], ['PI', 'Piauí'], ['RJ', 'Rio de Janeiro'], ['RN', 'Rio Grande do Norte'],
  ['RS', 'Rio Grande do Sul'], ['RO', 'Rondônia'], ['RR', 'Roraima'], ['SC', 'Santa Catarina'],
  ['SP', 'São Paulo'], ['SE', 'Sergipe'], ['TO', 'Tocantins'],
];
